export default () => {
  const benefits = document.querySelectorAll('.benefits');

  benefits.forEach((block) => {
    const items = block.querySelectorAll('.benefits__item');

    function closeAll() {
      items.forEach((item) => {
        item.classList.remove('active');
      });
    }

    items.forEach((item) => {
      const head = item.querySelector('.benefits__item-head');

      head.addEventListener('click', () => {
        if (item.classList.contains('active')) {
          item.classList.remove('active');
        } else {
          closeAll();
          item.classList.add('active');
        }
      });

      const handleKeyDown = (event) => {
        if (event.code === 'Enter') {
          item.classList.add('hover');
        }
      };

      item.addEventListener('focus', () => {
        item.addEventListener('keydown', handleKeyDown);
      });

      item.addEventListener('blur', () => {
        item.removeEventListener('keydown', handleKeyDown);
        item.classList.remove('hover');
      });
    });
  });
};
